import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { ChangeNumberComponent } from 'src/app/shared/components/change-number/change-number.component';
import { DeactivateAccountComponent } from 'src/app/shared/components/deactivate-account/deactivate-account.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-privacy-settings',
  templateUrl: './privacy-settings.component.html',
  styleUrls: ['./privacy-settings.component.scss']
})
export class PrivacySettingsComponent implements OnInit {
  loader:boolean=false
  userDetail:any
  panelState: any = [
    true,false,false,false,false
  ]
  private _apiSubscription: Subscription = new Subscription();
  constructor(private _navService: NavigationService,private _modelRef: MatDialog, private loaderService: LoaderServiceService, private _apiService: ApiService) {
    this._navService.hideSidebarAndNav = false;
    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
       
      if(resData.responseType === SM_CONSTANTS.GET_USER_DETAIL_RESULT){
        this.userDetail = {}
        if(resData.result){
          this.userDetail = resData.result
          this.toShowCheckProfile = this.userDetail.isPrivate
          this.toShowCheckNotifications = this.userDetail.doNotDisturb
          if(this.userDetail.addressInfo && this.userDetail.addressInfo != 'null'){
        
            this.userDetail.addressInfo = (typeof this.userDetail.addressInfo == 'string') ? JSON.parse(this.userDetail.addressInfo) : this.userDetail.addressInfo
          }
        }


        this.loaderService.showLoader = false
        this.loader = false;
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_USER_PROFILE){
        if(resData.result){
          // this.loader = true;
          // this.loaderService.showLoader = true;
          this._apiService.getUserDetail(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID))
        }

      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_SET_NOTIFICATION_PRIVACY){
        if(resData.result){
          // this.loader = true;
          // this.loaderService.showLoader = true;
          this._apiService.getUserDetail(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID))
        }

      }
      
    });
   }

  ngOnInit(): void {
      this.loader = true;
      this.loaderService.showLoader = true;
      this._apiService.getUserDetail(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID))
  }
  toShowCheckProfile: number = 1
  toShowCheckNotifications: number = 1
  onToggleChangeProfile(event: any) {
    if(event.checked){
      this.toShowCheckProfile = 1
      let data = {
        profileInfo: {
          profileHashId: this.userDetail.profileHashId,
          name: this.userDetail.name,
             email: this.userDetail.email,
          phone: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_PHONE_NUMBER),
          gender: this.userDetail.gender,
          shortBio: this.userDetail.shortBio,
          dob: this.userDetail.dateOfBirth &&  this.userDetail.dateOfBirth!= 'null' ? this.userDetail.dateOfBirth.slice(0,10):null,
          userType: this.userDetail.userType,
          searchType: 1,
          isPrivate: 0,
          
          addressInfo: this.userDetail.addressInfo,
          assetInfo: {
            thumbImgUrl: this.userDetail.profileThumbImg,
            imgUrl:this.userDetail.profileImg
          },
          origin: 'business'

        }
      }
      this.loaderService.showLoader = true
      // this.loader = true
      this._apiService.updateUserProfile(data)
    }
    else if (!event.checked){
      this.toShowCheckProfile = 0
      let data = {
        profileInfo: {
          profileHashId: this.userDetail.profileHashId,
          name: this.userDetail.name,
             email: this.userDetail.email,
          phone: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_PHONE_NUMBER),
          gender: this.userDetail.gender,
          shortBio: this.userDetail.shortBio,
          dob: this.userDetail.dateOfBirth &&  this.userDetail.dateOfBirth!= 'null' ? this.userDetail.dateOfBirth.slice(0,10):null,
          userType: this.userDetail.userType,
          searchType: 1,
          isPrivate: 1,
          addressInfo: this.userDetail.addressInfo,
          assetInfo: {
            thumbImgUrl: this.userDetail.profileThumbImg,
            imgUrl:this.userDetail.profileImg
          },
          origin: 'business'

        }
      }
      this.loaderService.showLoader = true
      // this.loader = true
      this._apiService.updateUserProfile(data)
    }
  }
  onToggleChangeNotifications(event: any) {
    if(event.checked){
      this.toShowCheckNotifications = 1
    
      this.loaderService.showLoader = true
      // this.loader = true
      this._apiService.setNotificationPrivacy('0')
    }
    else if (!event.checked){
      this.toShowCheckNotifications = 0
     
      this.loaderService.showLoader = true
      // this.loader = true
      this._apiService.setNotificationPrivacy('1')
    }
  }
  openDeactivate(){
    this._modelRef.open(DeactivateAccountComponent, {
      width: '500px',
      data: {
        title: 'De-activate account',
        ref: this._modelRef
      },
    });
  }


  isOpen = false;

  toggle() {
    this.isOpen = !this.isOpen;
  }

  changeNumber(){
    this._modelRef.open(ChangeNumberComponent, {
      width: '500px',
      data: {
        title: 'Change Phone Number',
        ref: this._modelRef,
      },
    });
  }


}
